import styled from '@emotion/styled';
import { Region } from '@kaizenplatform/hugot-entity';
import {
  Button,
  Card,
  CardActions as _CardActions,
  CardContent as _CardContent,
  CardHeader as _CardHeader,
  Grid,
  Typography,
} from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../../../theme';
import JPDirectionTypeAdPanel from '../../component/primitive/DirectionTypeAdPanel';
import JPDirectionTypeOtherPanel from '../../component/primitive/DirectionTypeOtherPanel';
import { SCREEN_LARGE } from '../../constant/pageWidth';
import { SPACING_HUGE, SPACING_LARGE, SPACING_REGULAR, SPACING_UNIT } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';
import mq from '../../styleUtility/mediaquery';

type Props = {
  onClickAdType: () => void;
  onClickOtherType: () => void;
  className?: string;
  region: Region;
};

const DirectionTypesPage: FC<Props> = ({ onClickAdType, onClickOtherType, className, region }) => {
  switch (region) {
    case 'jp':
      return (
        <Root className={className}>
          <Heading variant="h5">
            <FormattedMessage id="direction_type_page.title" />
          </Heading>
          <Grid container direction="row" justifyContent="flex-start" alignItems="stretch" spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Card>
                <JPCardHeader
                  title={
                    <Title variant="h6">
                      <FormattedMessage id="direction_type_page.ad.heading" />
                    </Title>
                  }
                  subheader={
                    <Typography variant="body2">
                      <FormattedMessage id="direction_type_page.ad.description" />
                    </Typography>
                  }
                />
                <CardContent>
                  <JPAdPanel>
                    <JPDirectionTypeAdPanel />
                  </JPAdPanel>
                </CardContent>
                <CardActions>
                  <Button onClick={onClickAdType}>
                    <FormattedMessage id="direction_type_page.buttons.submit" />
                  </Button>
                </CardActions>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Card>
                <JPCardHeader
                  title={
                    <Title variant="h6">
                      <FormattedMessage id="direction_type_page.other.heading" />
                    </Title>
                  }
                  subheader={
                    <Typography variant="body2">
                      <FormattedMessage id="direction_type_page.other.description" />
                    </Typography>
                  }
                />
                <CardContent>
                  <JPOtherPanel>
                    <JPDirectionTypeOtherPanel />
                  </JPOtherPanel>
                </CardContent>
                <CardActions>
                  <Button onClick={onClickOtherType}>
                    <FormattedMessage id="direction_type_page.buttons.submit" />
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Root>
      );
    case 'us':
      return (
        <Root className={className}>
          <Heading variant="h5">
            <FormattedMessage id="us_direction_type_page.title" />
          </Heading>
          <Grid container direction="row" justifyContent="flex-start" alignItems="stretch" spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Card>
                <CardHeader
                  title={
                    <Title variant="h6">
                      <FormattedMessage id="us_direction_type_page.ad.heading" />
                    </Title>
                  }
                  subheader={
                    <Typography variant="body2">
                      <FormattedMessage id="us_direction_type_page.ad.description" />
                    </Typography>
                  }
                />
                <CardContent>
                  <Panel>
                    <DirectionTypePanel src="/assets/USDirectionTypeAdPanel.png" />
                  </Panel>
                </CardContent>
                <CardActions>
                  <Button onClick={onClickAdType}>
                    <FormattedMessage id="us_direction_type_page.buttons.ad_submit" />
                  </Button>
                </CardActions>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Card>
                <CardHeader
                  title={
                    <Title variant="h6">
                      <FormattedMessage id="us_direction_type_page.other.heading" />
                    </Title>
                  }
                  subheader={
                    <Typography variant="body2">
                      <FormattedMessage id="us_direction_type_page.other.description" />
                    </Typography>
                  }
                />
                <CardContent>
                  <Panel>
                    <DirectionTypePanel src="/assets/USDirectionTypeOtherPanel.png" />
                  </Panel>
                </CardContent>
                <CardActions>
                  <Button color="primary" variant="contained" onClick={onClickOtherType}>
                    <FormattedMessage id="us_direction_type_page.buttons.other_submit" />
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Root>
      );
    case 'gl':
      return (
        <Root className={className}>
          <Heading variant="h5">
            <FormattedMessage id="us_direction_type_page.title" />
          </Heading>
          <Grid container direction="row" justifyContent="flex-start" alignItems="stretch" spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Card>
                <CardHeader
                  title={
                    <Title variant="h6">
                      <FormattedMessage id="gl_direction_type_page.ad.heading" />
                    </Title>
                  }
                  subheader={
                    <Typography variant="body2">
                      <FormattedMessage id="gl_direction_type_page.ad.description" />
                    </Typography>
                  }
                />
                <CardContent>
                  <Panel>
                    <DirectionTypePanel src="/assets/GLDirectionTypeAdPanel.png" />
                  </Panel>
                </CardContent>
                <CardActions>
                  <Button color="primary" variant="contained" onClick={onClickAdType}>
                    <FormattedMessage id="us_direction_type_page.buttons.ad_submit" />
                  </Button>
                </CardActions>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Card>
                <CardHeader
                  title={
                    <Title variant="h6">
                      <FormattedMessage id="us_direction_type_page.other.heading" />
                    </Title>
                  }
                  subheader={
                    <Typography variant="body2">
                      <FormattedMessage id="us_direction_type_page.other.description" />
                    </Typography>
                  }
                />
                <CardContent>
                  <Panel>
                    <DirectionTypePanel src="/assets/GLDirectionTypeOtherPanel.png" />
                  </Panel>
                </CardContent>
                <CardActions>
                  <Button color="primary" variant="contained" onClick={onClickOtherType}>
                    <FormattedMessage id="us_direction_type_page.buttons.other_submit" />
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Root>
      );
  }
};

const Root = styled('section')`
  width: auto;
  max-width: ${SCREEN_LARGE}px;
  margin-top: ${SPACING_HUGE}px;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: ${SPACING_UNIT * 12}px;
  ${mq('sp')} {
    padding-left: ${SPACING_REGULAR}px;
    padding-right: ${SPACING_REGULAR}px;
    padding-bottom: ${SPACING_UNIT * 6}px;
  }
`;

const JPCardHeader = styled(_CardHeader)`
  min-height: 106px;
  align-items: flex-start;
  ${mq('sp')} {
    min-height: auto;
    align-items: center;
  }
`;

const CardHeader = styled(_CardHeader)`
  min-height: 200px;
  align-items: flex-start;

  ${theme.breakpoints.down('sm')} {
    min-height: auto;
  }

  ${mq('sp')} {
    min-height: auto;
    align-items: center;
  }
`;

const CardContent = styled(_CardContent)`
  padding: 0;
`;

const CardActions = styled(_CardActions)`
  justify-content: center;
  padding-top: ${SPACING_REGULAR}px;
  padding-bottom: ${SPACING_REGULAR}px;
`;

const Heading = styled(Typography)`
  margin-bottom: ${SPACING_LARGE}px;
`;

const Title = styled(Typography)`
  font-weight: bold;
`;

const DirectionTypePanel = styled('img')`
  height: 100%;
  ${mq('sp')} {
    width: 100%;
    object-fit: contain;
    padding: 0;
    transform: scale(1);
  }
`;

const Panel = styled('div')`
  ${flexibleLayoutContainer({
    alignItems: 'center',
    justifyContent: 'center',
  })}
  width: 100%;
  height: 400px;
  padding: ${SPACING_UNIT}px;
  ${mq('sp')} {
    padding: 0;
  }
`;

const JPAdPanel = styled('div')`
  ${flexibleLayoutContainer({
    alignItems: 'center',
    justifyContent: 'center',
  })}
  width: 100%;
  height: 400px;
  padding: ${SPACING_UNIT}px;
  background: ${theme.palette.grey[100]};

  ${mq('sp')} {
    height: 100%;
    padding: 0;
  }
`;

const JPOtherPanel = styled('div')`
  ${flexibleLayoutContainer({
    alignItems: 'center',
    justifyContent: 'center',
  })}
  width: 100%;
  height: 400px;
  padding: ${SPACING_UNIT}px;
  background: ${theme.palette.grey[100]};
  ${mq('sp')} {
    height: 360px;
    padding: 0;
  }
`;

export default DirectionTypesPage;
